import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";

export interface GradeX {
  id: number;
  descricao?: string;
  isInativo: boolean;
}

export interface GradeXFormData {
  descricao?: string;
  isInativo?: boolean;
}

export function useGradesX() {
  const queryClient = useQueryClient();

  const { data: gradesX = [], isLoading } = useQuery({
    queryKey: ["grades-x"],
    queryFn: async () => {
      const { data } = await apiClient.get<GradeX[]>("/api/grades-x");
      return data;
    },
  });

  const createGradeX = useMutation({
    mutationFn: async (formData: GradeXFormData) => {
      const { data } = await apiClient.post<GradeX>("/api/grades-x", formData);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["grades-x"] });
      toast.success("Grade X criada com sucesso!");
    },
    onError: (error: Error) => {
      toast.error("Erro ao criar Grade X: " + error.message);
    },
  });

  const updateGradeX = useMutation({
    mutationFn: async ({ id, ...formData }: GradeXFormData & { id: number }) => {
      const { data } = await apiClient.put<GradeX>(`/api/grades-x/${id}`, formData);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["grades-x"] });
      toast.success("Grade X atualizada com sucesso!");
    },
    onError: (error: Error) => {
      toast.error("Erro ao atualizar Grade X: " + error.message);
    },
  });

  const deleteGradeX = useMutation({
    mutationFn: async (id: number) => {
      await apiClient.delete(`/api/grades-x/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["grades-x"] });
      toast.success("Grade X inativada com sucesso!");
    },
    onError: (error: Error) => {
      toast.error("Erro ao inativar Grade X: " + error.message);
    },
  });

  return {
    gradesX,
    isLoading,
    createGradeX,
    updateGradeX,
    deleteGradeX,
  };
}
